import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'emotion-theming';

import { ButtonWrapper, ButtonText } from './MenuIconButton.styles';

const MenuIconButton = ({ onClick, label, disabled, icon, textStyle }) => {
  const theme = useTheme();

  const styledIcon = useMemo(
    () =>
      icon
        ? React.cloneElement(icon, {
            style: {
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              color: theme.getColor('background'),
            },
          })
        : false,
    [theme, icon],
  );

  const adaptedTextStyle = textStyle || {};

  return (
    <ButtonWrapper
      onClick={onClick}
      onKeyDown={onClick}
      role="presentation"
      disabled={disabled}
    >
      <ButtonText style={adaptedTextStyle}>{label}</ButtonText>
      {styledIcon && (
        <div
          style={{
            width: '21px',
            height: '21px',
            marginLeft: theme.getSpacing(1, 'px'),
          }}
        >
          {styledIcon}
        </div>
      )}
    </ButtonWrapper>
  );
};

MenuIconButton.defaultProps = {
  label: '',
  disabled: false,
  icon: null,
  textStyle: null,
};

MenuIconButton.propTypes = {
  icon: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.node,
    PropTypes.element,
  ]),
  textStyle: PropTypes.object,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
};

export default MenuIconButton;
